import {useMemo} from 'react'

import type {MemexItemModel} from '../../../models/memex-item-model'
import {columnGetSize} from '../helpers/column-api'
import {columnWidthVariable} from '../helpers/column-width-variable'
import type {ColumnInstance} from '../helpers/types'
import {useTableColumnResizing} from '../providers/table-provider'

/**
 * Returns a mapping of CSS variable names to column widths. Intended for injection
 * into a component's style block to be applied using the getCellStylesFromColumn
 * helper.
 */
export function useColumnWidthVariables(columns: Array<ColumnInstance<MemexItemModel>>): {[key: string]: number} {
  const columnWidths = useTableColumnResizing()

  return useMemo(() => {
    const columnWidthVariables: {[key: string]: number} = {}

    for (const column of columns) {
      const resizingWidth: number = columnWidths[column.id] || columnGetSize(column)

      // Ensure the column is at least as wide as either its current width (which is
      // bound at the low end by MIN_CELL_WIDTH) or the resizing width
      columnWidthVariables[columnWidthVariable(column.id)] = Math.max(columnGetSize(column), resizingWidth)
    }

    return columnWidthVariables
  }, [columns, columnWidths])
}
